    <div class="modal-content">
      <div class="modal-header">
        <div class="row align-items-center">
          <div class="col-12 text-center">
            <h2>Bill Found</h2>
            <!-- <h2>{{detailsList.biller_name}}</h2> -->
          </div>
          <button (click)="close()" class="close-modal">
            <i class="icon-cross-small"></i>
          </button>
        </div>
      </div>
      <div class="modal-body border-0">
        <div class="d-flex justify-content-end ">
          <img src="assets/img/bbps/bharat-connect.png" alt="barat-connect" />
        </div>
        <div class="table-responsive mb-4">
          <table class="table table-borderless border-0">
            <tbody>
              <tr *ngFor="let biller of billerdetails | keyvalue : originalOrder">
             @if(biller?.key != 'biller_id' && biller?.key != 'ref_id'){
              <td>{{(biller.key | validate) ?? 'N/A'}}</td>
              <td>:</td>
                  <td  >{{ biller?.value !== null && biller?.value !== undefined && biller?.value !== ''  ? biller.value : 'N/A' }}</td>
             }
              </tr>
              <!-- <tr *ngIf="
                  billerInfo?.billpay_type == 'EXACT_ABOVE' &&
                  !validateUser?.charges
                ">
                <td>Payble Amount</td>
                <td>:</td>
                <td>
                  <input (keyup)="validateAmount($event)" [min]="max" type="number" class="form-control"
                    placeholder="Bill Amount..." [(ngModel)]="paybleAmount" [formControl]="myControl"
                    [class.is-invalid]="errorMessage" />
                  <div *ngIf="errorMessage" class="text-danger">
                    {{ errorMessage }}
                  </div>
                </td>
              </tr> -->
              <!-- <tr *ngIf="
                  billerInfo?.billpay_type == 'EXACT_BELOW' &&
                  !validateUser?.charges
                ">
                <td>Payble Amount</td>
                <td>:</td>
                <td>
                  <input (keyup)="validateAmount($event)" [max]="max" [min]="1" type="number" class="form-control"
                    placeholder="Bill Amount..." [(ngModel)]="paybleAmount" [formControl]="myControl"
                    [class.is-invalid]="errorMessage" />
                  <div *ngIf="errorMessage" class="text-danger">
                    {{ errorMessage }}
                  </div>
                </td>
              </tr> -->

            </tbody>
          </table>
        </div>
        <!-- last active function for Proceed -->

        <!-- <div *ngIf="!validateUser?.charges" class="text-center">
          <button (click)="fetchData()" [ngClass]="{ 'opacity-50 cursor-not-allowed': !myControl.valid }"
            [disabled]="!myControl.valid" type="button" class="custom-btn custom-btn-primary">
            Proceed
          </button>

        </div> -->




        <!-- <div *ngIf="validateUser?.charges" [ngClass]="{ 'opacity-50 cursor-not-allowed': !myControl.valid }"
          class="actions d-flex flex-wrap justify-content-center gap-3 mt-5">
          <button class="custom-btn custom-btn-cancel" (click)="back()">Back</button>
          <button type="button" class="custom-btn custom-btn-primary" (click)="submit()">Pay
          </button>
          
        </div> -->

        <!-- *ngIf="validateUser?.charges" -->

        <div class="text-center" [ngClass]="{ 'opacity-50 cursor-not-allowed': !myControl.valid }">
          <button type="button" class="custom-btn custom-btn-primary" (click)="submit()">
            Make Payment
          </button>

        </div>

      </div>
    </div>
